const getColorCode = (code: number) => {
  if (code >= 200 && code <= 300) return 'green';
  if (code === 503) return 'gold';
  if (code) return 'red';
  return '';
};

export default getColorCode;
